import NotificationReceiversType from './NotificationReceiversType'

export default NotificationReceiversType
